import * as _ from 'lodash';
import { IPreSelectHistory } from '@nkr/models/index';
import { GridWrapper } from './styles';
import { AgGridReact } from 'ag-grid-react';
import {
    IHeaderParams, GridReadyEvent,
    ValueGetterParams, FirstDataRenderedEvent, ICellRendererParams, SortChangedEvent
} from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { Button } from 'react-bootstrap';
import { useMemo } from 'react';

interface IProps {
    isAdmin: boolean,
    report: IPreSelectHistory[],
    onGridReady: (e: GridReadyEvent) => void,
    onPreselectHistoryDetails: (centerId: number) => void
}

const PreSelectHistoryByCenterReportGrid = (props: IProps) => {
    const columns = [
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    R#
                </SortableHeaderComponent>,
            headerName: 'Rank',
            width: 55,
            sortable: false,
            resizable: true,
            suppressSizeToFit: true,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },
        {
            colId: 'centerAlias',
            field: 'centerAlias',
            headerName: 'Center Alias',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Center Alias
                </SortableHeaderComponent>,
            width: 220,
            cellRendererFramework: (params: ICellRendererParams) => {
                return <span><Button bsSize='xs' bsStyle='link' style={{ marginRight: 5 }} onClick={() => props.onPreselectHistoryDetails(params.data.centerId)}>{params.data.centerAlias}</Button></span>;
            }
        },
        {
            colId: 'adjustedComplianceAverage',
            field: 'adjustedComplianceAverage',
            headerName: 'Adjusted Compliance Average',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Adjusted Compliance Average
                </SortableHeaderComponent>,
            width: 320,
            cellRendererFramework: (props: ICellRendererParams) => {
                return <span>{props.data.adjustedComplianceAverage}%</span>;
            }
        },
        {
            colId: 'preselectReversalCount',
            field: 'preselectReversalCount',
            headerName: 'Month\'s Preselect Reversal',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Month's Preselect Reversal
                </SortableHeaderComponent>,
            width: 370,
        }
    ]

    const onGridReady = (e: GridReadyEvent) => {
        e.api.sizeColumnsToFit();
        props.onGridReady(e);
    }


    const columnDefs = useMemo(() => columns, []);
    const rowData = useMemo(() => props.report, [props.report]);

    return (
        <div style={{ width: '50%' }}>
            <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 20 }}>
                <AgGridReact
                    defaultColDef={{
                        cellClass: 'center-list-cell',
                        headerClass: 'center-list-header',
                        sortable: true,
                        resizable: true,
                    }}
                    columnDefs={columnDefs}
                    rowData={rowData}
                    noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                    enableCellTextSelection={true}
                    enableRangeSelection={true}
                    onGridReady={onGridReady}
                    onFirstDataRendered={(e: FirstDataRenderedEvent) => e.api.sizeColumnsToFit()}
                    suppressCellSelection={true}
                    onSortChanged={(e: SortChangedEvent) => { e.api.refreshCells(); }}
                    getRowStyle={(props: any) => {
                        let data = props.data as IPreSelectHistory;

                        if (data.preselectReversalCount > 0) {
                            return { backgroundColor: 'yellow', fontWeight: 700 } as any;
                        }
                    }}
                />
            </GridWrapper>
        </div>
    );
}

export default PreSelectHistoryByCenterReportGrid;